import {Component, Input} from '@angular/core';

@Component({
    selector: 'mm-help-icon-link',
    templateUrl: './help-icon-link.component.html',
    styleUrl: './help-icon-link.component.scss',
    standalone: false
})
export class HelpIconLinkComponent {
    @Input({required: true})
    public link!: string;

    @Input({required: true})
    public title!: string;

}
